<template>
  <div>
    <div :class="computedClasses">{{ label }}</div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    h1: Boolean,
    h2: Boolean,
    h3: Boolean,
    h4: Boolean,
    h5: Boolean,
    h6: Boolean,
    h7: Boolean,
    h8: Boolean,
    fontSize: String,
    regular: Boolean,
    medium: Boolean,
    semiBold: Boolean,
    bold: Boolean,
    left: Boolean,
    center: Boolean,
    right: Boolean,
    color: String,
  },
  data() {
    return {
      label: this.label,
      classes: [],
    }
  },
  computed: {
    computedClasses() {
      let classes = []

      // Add the color class
      classes.push(this.color || 'color-darkBlue')

      // Add the font size class based on the heading boolean props and font size prop
      const headingSizeMap = {
        h1: 32,
        h2: 24,
        h3: 20,
        h4: 18,
        h5: 16,
        h6: 14,
        h7: 12,
        h8: 10,
      }
      let headingSize = null
      for (let i = 1; i <= 8; i++) {
        if (this[`h${i}`]) {
          headingSize = headingSizeMap[`h${i}`]
          break
        }
      }
      const fontSize = this.fontSize || headingSize || 16
      classes.push(`fs-${fontSize}`)

      // Add the font weight class based on the props
      if (this.bold) {
        classes.push('bold')
      } else if (this.semiBold) {
        classes.push('semiBold')
      } else if (this.medium) {
        classes.push('medium')
      } else {
        classes.push('regular')
      }

      // Add the text align class based on the props
      if (this.left) {
        classes.push('text-left')
      } else if (this.center) {
        classes.push('text-center')
      } else if (this.right) {
        classes.push('text-right')
      }

      return classes.join(' ')
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/Typography.vue